var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 22.5H23.2031V12.5391C23.2031 8.40527 20.1475 4.98633 16.1719 4.41797V3.28125C16.1719 2.63379 15.6475 2.10938 15 2.10938C14.3525 2.10938 13.8281 2.63379 13.8281 3.28125V4.41797C9.85254 4.98633 6.79688 8.40527 6.79688 12.5391V22.5H6.09375C5.5752 22.5 5.15625 22.9189 5.15625 23.4375V24.375C5.15625 24.5039 5.26172 24.6094 5.39062 24.6094H11.7188C11.7188 26.4199 13.1895 27.8906 15 27.8906C16.8105 27.8906 18.2812 26.4199 18.2812 24.6094H24.6094C24.7383 24.6094 24.8438 24.5039 24.8438 24.375V23.4375C24.8438 22.9189 24.4248 22.5 23.9062 22.5ZM15 26.0156C14.2236 26.0156 13.5938 25.3857 13.5938 24.6094H16.4062C16.4062 25.3857 15.7764 26.0156 15 26.0156Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.640792bce00e498e6fe43f2d1e752916.svg";
export { ForwardRef as ReactComponent };